import { formatDatetime } from 'common/utils/file';

export const SYNC_HISTORY_HEADER_TITLE = 'Sync History';

export const getSyncLogsListColDefs = (data: any, minWidth = 50) => [
    {
        field: 'logId',
        headerName: 'Request#',
        minWidth: minWidth,
        width: 450,
        resizable: true,
        cellRenderer: 'CopyLabelCellRenderer'
    },
    {
        field: 'uploadedUser.displayName',
        headerName: 'Triggered by',
        minWidth: minWidth,
        width: 550,
        resizable: true,
        cellRenderer: 'LabelCellRenderer',
        cellRendererParams: {
            className: 'triggered-by'
        }
    },
    {
        field: 'uploadedOn',
        headerName: 'Triggered At',
        minWidth: minWidth,
        width: 600,
        resizable: true,
        cellRenderer: 'LabelCellRenderer',
        cellRendererParams: {
            className: 'indicator'
        },
        valueFormatter: (params: any) => formatDatetime(params.value)
    },
    {
        field: 'sourceSchema',
        headerName: 'Source',
        minWidth: minWidth,
        width: 400,
        resizable: true,
        cellRenderer: 'LabelCellRenderer',
        cellRendererParams: {
            className: 'indicator'
        }
    },
    {
        field: 'targetSchema',
        headerName: 'Target',
        minWidth: minWidth,
        width: 400,
        resizable: true,
        cellRenderer: 'LabelCellRenderer',
        cellRendererParams: {
            className: 'indicator'
        }
    },
    {
        field: 'statusName',
        headerName: 'Status',
        minWidth: minWidth,
        width: 300,
        resizable: true,
        cellRenderer: 'LabelCellRenderer',
        cellRendererParams: {
            className: 'indicator'
        }
    }
];
